export default __webpack_public_path__ + "static/media/userInfo.92e1d2a7.jpg";